export default {
    pageTitle: 'Commandes',
    listing: {
        content: 'Type de licence',
        date: 'Date de création',
        new: 'Commander',
        number: '# Commande',
        pageTitle: 'Commandes',
        quantity: 'Quantité',
        remainingLicenses: 'Restantes',
        status: 'Statut',
        noOrders: 'Aucune commande.',
        hideCompleted: 'Cacher commandes complétées',
        stats: {
            available: 'Licences disponibles',
            activated: 'Licences activées',
            purchased: 'Licences achetées',
        },
        yearToDate: 'AAJ',
    },
    modal: {
        cancel: 'Annuler',
        error: {
            input: 'Les valeurs données ne respectent pas les critères de validation',
            invalidData: 'Les valeurs données sont invalides',
        },
        instructions: 'Une fois la commande envoyée, notre équipe la validera et émettra les licences.',
        licenseType: 'Type de licence',
        quantity: 'Quantité',
        send: 'Commander',
        title: 'Nouvelle commande',
    },
    activations: {
        activateLicense: 'Activer une licence',
        activations: 'Activations',
        activationsHistory: 'Historique des activations',
        noActivations: 'Aucune activation.',
        activationForm: {
            availableLicenses: '{count} licences restantes',
            activate: 'Activer',
            licenseType: 'Type de licence',
            afsSerial: 'Numéro de licence AFS',
            afsVersion: "Version de l'AFS",
            deviceSerial: "Numéro de série de l'appareil",
            phoneSerial: 'Numéro de série du téléphone',
            phoneModel: 'Modèle du téléphone',
            androidVersion: "Version d'Android",
            computerSerial: "Numéro de série de l'ordinateur",
            firmwareVersion: 'Version du firmware',
            latestVersion: 'Actuelle: ',
            errors: {
                activationFailed: 'Impossible d\'activer la licence avec les paramètres fournis.',
            },
        },
        licenseKeyModal: {
            title: "Clé d'activation",
            button: 'Fermer',
            copiedToClipboard: "La clé d'activation a été copiée dans le presse-papier.",
        },
        search: 'Rechercher...',
    },
};
